import { styled as muiStyled, Paper } from '@mui/material'
import FullCalendar from '@fullcalendar/react'

export const RosterPageContainer = muiStyled('div')(
  ({ theme, disableGrid = false }) => `
    margin: 0 auto;
    padding: 10px;
    width: 100%;
    flex-grow: 1;
    display: ${disableGrid ? 'block' : 'grid'};
    grid-template-columns: ${disableGrid ? '1fr' : '1fr 4fr'};
`,
)

export const StyledRosterCalendarComponentContainer = muiStyled('div')(
  ({ theme }) => `
  height: 100%;
    .fc {
        height: 100%;
        }
    .fc-view-harness {
        height: 100% !important;
    }
`,
)

export const BookingInfoDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
    max-width: 700px !important;
    width: 100% !important;
    margin: 0!important;
    max-height: 100vh !important;
    @media (min-width: 980px) {
    max-height: calc(100% - 64px)!important;
    }
    `,
)
